import { useState, useEffect, useCallback } from 'react'
import { isEmpty, objectMapper, olog, } from '@haina/utils-commons'
import { readIndexDB } from '@/utils/indexedDB'
import { getEmailDetailAction, postResendEmailAction, getSalesSignatureAction, getEmailOrderAction, queryEmailListAction, searchEmailListAction, getReminderEmailTemplateAction, saveEmailDraftOrSendAction, updateEmailAction, getEmailChangesChannel, EMAIL_CHANNEL_NAME } from '@/actions/EmailActions'
import { App } from 'antd'
import useConversationStore from '@/stores/ConversationStore';
import { msgStatusRenderMapped } from '@/channel/bubbleMsgUtils';
import { POPUP_FEATURES } from '@/config';
import { internalEventEmitter } from '@/utils/EventEmitterService';

export const useEmailSignature = (opi_sn) => {

  const [signature, setSignature] = useState('')

  const getSignature = useCallback(async () => {
    if (isEmpty(Number(opi_sn))) {
      return false
    }
    try {
      const data = await getSalesSignatureAction({ opi_sn })
      setSignature(data)
    } catch (err) {
      console.error(err)
    }
  }, [opi_sn])

  useEffect(() => {
    getSignature()
  }, [getSignature])

  return { signature }

}

/**
 * 邮件详情
 *
 * @param mai_sn 邮件编号ID
 * @param data 直接传递, 不重复获取
 * * 在详情点击`回复`呼出编辑时
 * @param {number|boolean} oid 订单ID
 * - If `number`: 直接传递, 直接获取订单详情
 * - If `false`: 不需要获取订单信息
 */
export const useEmailDetail = (mai_sn=0, data={}, oid=0, markRead=false) => {
  const {notification} = App.useApp()
  const [loading, setLoading] = useState(false)
  const [mailData, setMailData] = useState({ loading, info: { MAI_COLI_SN: 0 }, content: '', attachments: [], AttachList: [] })
  const [maiSN, setMaiSN] = useState(mai_sn);
  const [coliSN, setColiSN] = useState(oid);
  const [orderDetail, setOrderDetail] = useState({});

  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const refresh = useCallback(() => {
    setRefreshTrigger(prev => prev + 1);
  }, []);
  // console.log(maiSN, 'mailSN', mai_sn)

  // const [updateMessageItem] = useConversationStore(state => [state.updateMessageItem]);

  const getEmailDetail = useCallback(async () => {
    if (isEmpty(Number(maiSN)) && isEmpty(Number(mai_sn))) {
      return false
    }

    if (!isEmpty(data)) {
      setMailData(data)
      return false
    }

    try {
      setLoading(true)
      const data = await getEmailDetailAction({ mai_sn: Number(mai_sn) || maiSN })
      // console.log(data)
      setMailData(data)
      setColiSN(oid === false ? 0 : data.info.MAI_COLI_SN)
      setLoading(false)
      // `已读`
      if (markRead !== false && data.info?.MOI_ReadState !== 1) {
        updateEmailAction({
          opi_sn: data.info.MAI_OPI_SN,
          mai_sn_list: [Number(mai_sn) || maiSN],
          set: { read: 1 },
        })
      }
    } catch (err) {
      setLoading(false)
      notification.error({
        message: '请求失败',
        description: err.message || '网络异常',
        placement: 'top',
        duration: 3,
      })
    }
  }, [mai_sn, maiSN, refreshTrigger])


  const getOrderDetail = useCallback(async () => {
    // console.log(coliSN, '====colisn======')
    if (isEmpty(Number(coliSN))) {
      return false
    }
    try {
      setLoading(true)
      const data = await getEmailOrderAction({ colisn: coliSN })
      setOrderDetail(data)
      setLoading(false)
    } catch (err) {
      setLoading(false)
      notification.error({
        message: '请求失败',
        description: err.message || '网络异常',
        placement: 'top',
        duration: 3,
      })
    }
  }, [coliSN])

  useEffect(() => {
    getEmailDetail();
  }, [getEmailDetail])

  useEffect(() => {
    getOrderDetail()
  }, [getOrderDetail])

  const postEmailResend = async ({ mai_sn, conversationid: externalid, actionId: actionid, ...body }) => {
    if (isEmpty(Number(mai_sn))) {
      return false
    }
    await postResendEmailAction({ mai_sn, externalid, actionid, token: 0 })
  }

  const postEmailSaveOrSend = async (body, isDraft) => {
    const { id: savedID } = await saveEmailDraftOrSendAction(body, isDraft)
    setMaiSN(savedID)
    if (isDraft) {
      refresh()
    }
    return savedID
  };

  return { loading, mailData, orderDetail, postEmailResend, postEmailSaveOrSend }
}

export const EmailBuilder = ({subject, content}) => {
  return `<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd"><html lang="en"><head><title></title><meta http-equiv="Content-Type" content="text/html charset=UTF-8" /><meta content="width=device-width" name="viewport"><meta charset="UTF-8"><meta content="IE=edge" http-equiv="X-UA-Compatible"><meta content="width=device-width" name="viewport"><meta charset="UTF-8"><meta content="IE=edge" http-equiv="X-UA-Compatible"><meta content="telephone=no,address=no,email=no,date=no,url=no" name="format-detection"><meta content="light" name="color-scheme"><meta content="light" name="supported-color-schemes"><style id="font">body#highlights-email{ font-family: Verdana, sans-serif;} table{ border-collapse: collapse; border-spacing: 0;} </style></head><body id="highlights-email" style="margin: 0 auto; padding: 0; width: 900px; background-color: #fcfcfc;">${content}</body></html>`;
}

const objectToFeatureString = (obj) =>
  obj && typeof obj === 'object'
    ? Object.entries(obj)
        .map(([key, value]) => `${key}=${typeof value === 'boolean' ? (value ? 'yes' : 'no') : String(value)}`)
        .join(',')
    : '';
export const openPopup = (url, target, extraFeatures = {}) => {
  let features2 = objectToFeatureString(extraFeatures)
  let screenWidth = window.screen.availWidth;
  let screenHeight = window.screen.availHeight;
  features2 += extraFeatures?.fullscreen === true ? `,width=${screenWidth},height=${screenHeight}` : ''
  return window.open(url, target, POPUP_FEATURES+`,${features2}`);
};

export const useEmailList = (mailboxDirNode) => {
  const [loading, setLoading] = useState(false)
  const [mailList, setMailList] = useState([])
  const [error, setError] = useState(null)
  const [isFreshData, setIsFreshData] = useState(false)
  const [refreshTrigger, setRefreshTrigger] = useState(0)
  const [tempBreadcrumb, setTempBreadcrumb] = useState(null);

  const refresh = useCallback(() => {
    setRefreshTrigger((prev) => prev + 1)
  }, [])

  const { OPI_SN: opi_sn, COLI_SN, VKey, VParent, ApplyDate, OrderSourceType, IsTrue } = mailboxDirNode

  const markAsUnread = useCallback(
    async (sn_list) => {
    // 优化性能的话，需要更新 mailList 数据，
    // 但是更新 mailList 会造成页面全部刷新
    // 所以还是先用 refresh()
    // const updatedMailList = mailList.map(mail => {
    //   if (sn_list.includes(mail.MAI_SN)) {
    //     return { ...mail, MOI_ReadState: 1 };
    //   }
    //   return mail;
    // });
    // setMailList(updatedMailList);
    // setLoading(true)
      await updateEmailAction({
        opi_sn: opi_sn,
        mai_sn_list: sn_list,
        set: { read: 0 },
      })
    },
    [VKey],
  )

  const markAsProcessed = useCallback(
    async (sn_list) => {
      await updateEmailAction({
        opi_sn: opi_sn,
        mai_sn_list: sn_list,
        set: { processed: 1 },
      })
    },
    [VKey],
  )

  const markAsDeleted = useCallback(
    async (sn_list) => {
      await updateEmailAction({
        opi_sn: opi_sn,
        mai_sn_list: sn_list,
        set: { delete: 1 },
      })
    },
    [VKey],
  )

  const loadMailListFromCache = useCallback(async (payload) => {
    const cacheKey = isEmpty(COLI_SN) ? `dir-${VKey}` : `order-${VKey}`
    const readCacheIDList = await readIndexDB(cacheKey, 'maillist', 'mailbox')
    if (!isEmpty(readCacheIDList)) {
      const readCacheListRowsMap = await readIndexDB(readCacheIDList.data, 'listrow', 'mailbox')
      const _x = readCacheIDList.data.map((ele) => readCacheListRowsMap.get(ele).data || {})
      setMailList(_x)
      setLoading(false)
    }
  }, [VKey])

  const getMailList = useCallback(async () => {
    // console.log('getMailList', mailboxDirNode)
    if (!opi_sn || !VKey || (!IsTrue && !COLI_SN)) {
      setMailList([])
      setLoading(false)
      setError(null)
      setIsFreshData(false)
      return
    }
    setTempBreadcrumb(null)
    setLoading(true)
    setError(null)
    setIsFreshData(false)

    // const cacheKey = isEmpty(COLI_SN) ? `dir-${VKey}` : `order-${VKey}`
    try {
      // 1. 先从缓存读取
      await loadMailListFromCache();
      // 2. 从接口获取最新的列表
      const nodeParam = { coli_sn: COLI_SN, order_source_type: OrderSourceType, vkey: VKey, vparent: VParent, mai_senddate1: ApplyDate }
      const x = await queryEmailListAction({ opi_sn, node: nodeParam })
      // 配合List的结构
      const _x = x.map((ele) => ({
        ...ele,
        key: ele.MAI_SN,
      }))
      setMailList(_x)
    } catch (networkError) {
      setError(new Error(`Failed to get mail list: ${networkError.message}.`))
    } finally {
      setLoading(false)
    }
  }, [VKey, refreshTrigger])

  useEffect(() => {
    getMailList()
    // --- Setup Internal Event Listener ---
    const handleInternalUpdate = (event) => {
      // console.log(`🔔[useEmailList] Received internal event. `, event.detail)
      if (isEmpty(event.detail)) {
        return false;
      }
      const { type, } = event.detail
      if (type === 'listrow') {
        loadMailListFromCache()
      }
      if (type === 'maillist-search-result') {
        const { data, query } = event.detail
        setMailList(data)
        setTempBreadcrumb([{title: '查找邮件:'+query, iconIndex: 'search'}]);
      }
    }
    internalEventEmitter.on(EMAIL_CHANNEL_NAME, handleInternalUpdate)

    // --- Setup BroadcastChannel Listener ---
    const channel = getEmailChangesChannel()
    const handleMessage = (event) => {
      // console.log(`[useEmailList] Received channel event. `, event.data)
      if (isEmpty(event.data)) {
        return false;
      }
      const { type, } = event.data
      const cacheKey = isEmpty(COLI_SN) ? `dir-${VKey}` : `order-${VKey}`
      if (type === 'listrow' && cacheKey === event.data.listKey) {
        // cacheKey 不相同时, 不需要更新; 邮箱目录不相同
        loadMailListFromCache(event.data)
      }
      if (type === 'maillist-search-result') {
        // 搜索的结果不需要更新所有页面
        // const { data } = event.detail
        // setMailList(data)
      }
    }
    channel.addEventListener('message', handleMessage)

    // Cleanup
    return () => {
      internalEventEmitter.off(EMAIL_CHANNEL_NAME, handleInternalUpdate)
      channel.removeEventListener('message', handleMessage)
    }
  }, [getMailList])

  return { loading, isFreshData, error, mailList, tempBreadcrumb, refresh, markAsUnread, markAsProcessed, markAsDeleted }
}

const orderMailTypes = new Map([
  ['48001', '发送一催'],
  ['48002', '发送二催'],
  ['48003', '发送三催'],
  ['48004', '发送已收客人付款通知'],
  ['48005', '发送FAQ及PreSurvey'],
  ['48006', '发送降价邮件'],
  ['48007', '发送亚马逊津贴'],
  ['48008', '发送报价信'],
  ['48009', '提交调度'],
  ['48010', '发送确认信'],
  ['48011', '发送余款提醒信'],
  ['48012', '发送入境提醒'],
  ['48013', '首站关怀'],
  ['48014', '抵桂面谈'],
  ['48015', '末站关怀'],
  ['48016', '发送计划'],
  ['48017', '报价中'],
  ['48018', '以后联系'],
  ['48019', '成行'],
  ['48020', '团款收讫'],
  ['48021', '取消'],
  ['48022', '丢失'],
  ['48023', '已做计划'],
  ['48024', '一催回复'],
  ['48025', '二催回复'],
  ['48026', '第一次报价回复'],
  ['48027', '发送商务感谢信'],
  ['48028', '商务酒店房满邮件'],
  ['48029', '商务预订传真'],
  ['48030', '商务取消邮件'],
  ['48031', '商务单团财务表'],
  ['48032', '商务收款单'],
  ['48033', '商务退款单'],
  ['48034', '商务财务转帐申请'],
  ['48035', '商务未订先确认'],
  ['48036', '商务等待确认'],
  ['48037', '商务已确认'],
  ['48038', '商务已付款'],
  ['48039', '商务成功订单'],
  ['48040', '商务取消订单'],
  ['48041', '商务不成行订单'],
  ['48042', '商务已付款未出票'],
  ['48043', '商务已付款并出票'],
  ['48044', '商务无效订单'],
  ['48045', '问候提醒'],
  ['48046', '发送邮件'],
  ['48047', '来华一周年问候'],
  ['48048', '来华二周年提醒'],
  ['48049', 'CH Phone询问邮件'],
  ['48050', '订单电话销售'],
  ['48051', '等待付订金'],
  ['48052', '商务订单预订中'],
  ['48053', '客户需求调查'],
  ['48054', '发送TourCredits通知邮件'],
  ['48055', 'GH海外PostSurvey'],
])
export const emailTemplates = [
  { type: 'RemindOneWL', index: 1, key: '1@RemindOneWL', value: '1@RemindOneWL', label: '一催模版1：鼓励客人回复和讨论行程' },
  { type: 'RemindOneWL', index: 2, key: '2@RemindOneWL', value: '2@RemindOneWL', label: '一催模版2：询问客人对于报价是否有疑问' },
  { type: 'divider' },
  { type: 'RemindTwoWL', index: 1, key: '1@RemindTwoWL', value: '1@RemindTwoWL', label: '二催模版1：省钱的方式' },
  { type: 'RemindTwoWL', index: 2, key: '2@RemindTwoWL', value: '2@RemindTwoWL', label: '二催模版2：Why us' },
  { type: 'divider' },
  { type: 'RemindThreeWL', index: 1, key: '1@RemindThreeWL', value: '1@RemindThreeWL', label: '三催模版1：再次强调服务' },
  { type: 'RemindThreeWL', index: 2, key: '2@RemindThreeWL', value: '2@RemindThreeWL', label: '三催模版2：客人常见问题询问' },
];
export const emailTemplateMap = emailTemplates.reduce((acc, cur) => {
  if (cur.type === 'divider') {
    return acc
  }
  acc[cur.key] = cur
  return acc
}, {});

/**
 *
 * @param {object} params - Parameters for the email template request.
 * @param {number} [params.coli_sn] - Customer order line item serial number.
 * @param {number} [params.lgc] - Language code.
 * @param {number} [params.opi_sn] - Order product item serial number.
 */
export const useEmailTemplate = (templateKey, params) => {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [templateContent, setTemplateContent] = useState({ mailtype: '', mailtypeName: '', subject: '', mailcontent: '' })

  const getTemplateContent = useCallback(async () => {
    if  (!templateKey || !Number(params.coli_sn) || !Number(params.opi_sn)) {
      setTemplateContent({ mailtype: '', mailtypeName: '', subject: '', mailcontent: '' })
      setLoading(false)
      setError(null)
      return
    }
    setLoading(true)
    setError(null)
    try {
      const { index: remind_index, type: remind_type } = emailTemplateMap[templateKey] || {};
      const _params = { ...params, remind_index, remind_type};
      const x = await getReminderEmailTemplateAction(_params)
      const lowerCaseShallow = Object.keys(x).reduce((acc, key) => ({...acc, [key.toLowerCase()]: x[key]}), {})
      setTemplateContent({...lowerCaseShallow, mailtypeName: orderMailTypes.get(lowerCaseShallow.mailtype)})
    } catch (networkError) {
      setError(new Error(`Failed to get template content: ${networkError.message}.`))
    } finally {
      setLoading(false)
    }
  }, [templateKey, params.opi_sn, params.coli_sn, params.lgc])

  useEffect(() => {
    getTemplateContent()
  }, [getTemplateContent])

  return { loading, error, templateContent };
}

export const mailboxSystemDirs = [
  { key: 1, value: 1, label: '收件箱' },
  { key: 2, value: 2, label: '未读邮件' },
  { key: 3, value: 3, label: '已发邮件' },
  { key: 4, value: 4, label: '待发邮件' },
  { key: 5, value: 5, label: '草稿' },
  { key: 6, value: 6, label: '垃圾邮件' },
  { key: 7, value: 7, label: '已处理邮件' },
]

